import styled, { css } from "styled-components";
import {
  DESKTOP_BREAKPOINT,
  FOOTER_HEIGHT_DESKTOP,
  FOOTER_HEIGHT_MOBILE,
  HEADER_HEIGHT_DESKTOP,
  HEADER_HEIGHT_MOBILE,
} from "../../utils";

interface BaseContainerProps {
  $fullWidth?: boolean;
}

export const BaseContainer = styled.main<BaseContainerProps>`
  margin-top: ${HEADER_HEIGHT_DESKTOP}px;
  min-height: calc(
    100vh - ${HEADER_HEIGHT_DESKTOP}px - ${FOOTER_HEIGHT_DESKTOP}px
  );

  & > div {
    margin: auto;
    padding: 32px 16px;

    ${({ $fullWidth }) =>
      $fullWidth
        ? css`
            width: 100%;
            max-width: 100%;
          `
        : css`
            width: 1200px;
            max-width: 1200px;
          `}
  }

  @media (max-width: ${DESKTOP_BREAKPOINT}px) {
    margin-top: ${HEADER_HEIGHT_MOBILE}px;
    min-height: calc(
      100vh - ${HEADER_HEIGHT_MOBILE}px - ${FOOTER_HEIGHT_MOBILE}px
    );

    & > div {
      width: 100%;
      max-width: 100%;
    }
  }
`;
